import React, { Component } from 'react'
import styles from './index.css'

export default class Advertisement extends Component {
  render () {
    return (
      <a href="#" className={ styles.advertisement }>
        <img src="//placehold.it/280x160" alt="advertisement" />
      </a>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/Home/Aside/Advertisement.js
 **/